// Danish translations
export const da: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.orderNew': 'Produktregistrering',
  'menu.deliveryList': 'Leveringsliste',
  'menu.delivery': 'Levering',
  'menu.receipt': 'Udskriv kvittering/etiket',
  'menu.definitions': 'Definitioner',
  'menu.customers': 'Kunder',
  'menu.products': 'Produktdefinitioner',
  'menu.pricing': 'Prisdefinitioner',
  'menu.tailoring': 'Skrædderoperationer',
  'menu.attributes': 'Produktattributter',
  'menu.users': 'Brugere',
  'menu.productOrdering': 'Produktrækkefølge',
  'menu.discounts': 'Rabatdefinitioner',
  'menu.settings': 'Indstillinger',
  'menu.generalSettings': 'Generelle indstillinger',
  'menu.permissions': 'Tilladelsesstyring',
  'menu.subscription': 'Abonnement',
  'menu.invoices': 'Fakturastyring',
  'menu.expenses': 'Udgiftsregistrering',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Rapporter & Regnskab',
  'menu.systemAndCommunication': 'System & Kommunikation',
  'menu.reportsList': 'Kvitteringsliste',
  'menu.accountStatement': 'Kontoudskrift',
  'menu.tickets': 'Supportanmodninger',
  'menu.support': 'Support',
  'menu.profile': 'Profil',
  'menu.logout': 'Log ud',
  'menu.notifications': 'SMS/WhatsApp-notifikationer',
  'menu.whatsappConnection': 'WhatsApp-forbindelse',
  'menu.smsConnection': 'SMS-forbindelse',
  'dashboard.title': 'Dashboard',
  'dashboard.todaySales': 'Dagens salg',
  'dashboard.totalOrders': 'Samlede ordrer',
  'dashboard.pendingDeliveries': 'Afventende leveringer',
  'dashboard.activeCustomers': 'Aktive kunder',
  'dashboard.recentOrders': 'Seneste ordrer',
  'dashboard.viewAll': 'Vis alle',
  'dashboard.quickActions': 'Hurtige handlinger',
  'dashboard.newOrder': 'Ny ordre',
  'dashboard.newCustomer': 'Ny kunde',
  'dashboard.deliveries': 'Leveringer',
  'dashboard.reports': 'Rapporter',
  'dashboard.today': 'I dag',
  'dashboard.yesterday': 'I går',
  'dashboard.week': 'Uge',
  'dashboard.month': 'Måned',
  'dashboard.quarter': 'Kvartal',
  'dashboard.year': 'År',
  'dashboard.totalRevenue': 'Samlet omsætning',
  'dashboard.totalOrdersCard': 'Samlede ordrer',
  'dashboard.totalPieces': 'Samlede varer',
  'dashboard.cancelled': 'Annulleret',
  'dashboard.inProcess': 'Under behandling',
  'dashboard.inProcessDesc': 'Ordrer under behandling',
  'dashboard.ready': 'Klar',
  'dashboard.readyDesc': 'Ordrer klar til levering',
  'dashboard.delivered': 'Leveret',
  'dashboard.deliveredDesc': 'Afsluttede ordrer',
  'dashboard.announcements': 'Meddelelser',
  'dashboard.announcementAll': 'Generelt',
  'dashboard.announcementPrivate': 'Privat',
  'order.title': 'Ny ordre',
  'order.customer': 'Kunde',
  'order.selectCustomer': 'Vælg kunde',
  'order.newCustomer': 'Ny kunde',
  'order.products': 'Produkter',
  'order.addProduct': 'Tilføj produkt',
  'order.selectProduct': 'Vælg produkt',
  'order.quantity': 'Antal',
  'order.price': 'Pris',
  'order.total': 'Total',
  'order.discount': 'Rabat',
  'order.subtotal': 'Subtotal',
  'order.tax': 'Moms',
  'order.grandTotal': 'Samlet beløb',
  'order.payment': 'Betaling',
  'order.paymentMethod': 'Betalingsmetode',
  'order.cash': 'Kontant',
  'order.card': 'Kreditkort',
  'order.credit': 'Kredit',
  'order.amountPaid': 'Betalt beløb',
  'order.remainingBalance': 'Resterende saldo',
  'order.deliveryDate': 'Leveringsdato',
  'order.notes': 'Noter',
  'order.createOrder': 'Opret ordre',
  'order.cancel': 'Annuller',
  'users.title': 'Brugere',
  'users.addNew': 'Ny bruger',
  'users.name': 'Navn',
  'users.email': 'E-mail',
  'users.role': 'Rolle',
  'users.pin': 'PIN',
  'users.permissions': 'Tilladelser',
  'users.allPermissions': 'Alle tilladelser',
  'users.permissionCount': '{count} tilladelser',
  'users.changePin': 'Skift PIN',
  'users.edit': 'Rediger',
  'users.delete': 'Slet',
  'users.newUser': 'Ny bruger',
  'users.editUser': 'Rediger bruger',
  'users.editingUser': 'Redigerer {name}',
  'users.deleteUserTitle': 'Slet bruger',
  'users.deletingUser': 'Er du sikker på, at du vil slette {name}?',
  'users.pinCode': 'PIN-kode (4-6 cifre)',
  'users.selectRole': 'Vælg rolle',
  'users.patron': 'Ejer',
  'users.kasiyer': 'Kasserer',
  'users.sofor': 'Chauffør',
  'users.changePinTitle': 'Skift PIN-kode',
  'users.newPin': 'Ny PIN-kode',
  'users.confirmPin': 'Bekræft PIN-kode',
  'users.pinMismatch': 'PIN-koderne stemmer ikke overens',
  'users.pinRequired': 'PIN-kode påkrævet',
  'users.pinLength': 'PIN-koden skal være 4-6 cifre',
  'users.changingPinFor': 'Skifter PIN for {name}',
  'products.title': 'Produktdefinitioner',
  'products.addNew': 'Nyt produkt',
  'products.category': 'Kategori',
  'products.name': 'Produktnavn',
  'products.price': 'Pris',
  'products.color': 'Farve',
  'products.active': 'Aktiv',
  'products.actions': 'Handlinger',
  'products.search': 'Søg produkt...',
  'products.noProducts': 'Ingen produkter fundet',
  'products.noCategoryProducts': 'Ingen produkter i denne kategori',
  'products.emptyCart': 'Kurven er tom',
  'service.tailor': 'Skrædder',
  'service.dryCleaning': 'Renseri',
  'service.washing': 'Vask',
  'service.ironing': 'Strygning',
  'service.shoeShine': 'Skopudsning',
  'service.carpet': 'Tæppe',
  'service.tailoring': 'Skrædderændringer',
  'service.carpetWashing': 'Tæppevask',
  'service.selectService': 'Vælg service',
  'service.addToCart': 'Tilføj til kurv',
  'service.total': 'Total',
  'common.yes': 'Ja',
  'common.no': 'Nej',
  'common.cancel': 'Annuller',
  'common.confirm': 'Bekræft',
  'common.delete': 'Slet',
  'common.edit': 'Rediger',
  'common.save': 'Gem',
  'common.search': 'Søg',
  'common.loading': 'Indlæser...',
  'common.noData': 'Ingen data',
  'common.actions': 'Handlinger',
  'common.status': 'Status',
  'common.date': 'Dato',
  'common.time': 'Tid',
  'common.total': 'Total',
  'common.filter': 'Filtrer',
  'common.export': 'Eksporter',
  'common.print': 'Udskriv',
  'common.close': 'Luk',
  'common.back': 'Tilbage',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Send',
  'common.reset': 'Nulstil',
  'common.create': 'Opret',
  'common.creating': 'Opretter...',
  'common.later': 'Senere',
  'common.clear': 'Ryd',
  'common.copied': 'Kopieret!',
  'common.copyError': 'Kopiering mislykkedes',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Renseri Administrationssystem',
  'login.tenantId': 'Firma-ID',
  'login.tenantPlaceholder': 'firma-id (f.eks: acme-clean)',
  'login.tenantIdHelp': 'Indtast din unikke virksomhedsidentifikator',
  'login.continue': 'Fortsæt →',
  'login.notMember': 'Ikke medlem endnu?',
  'login.startTrial': 'Start gratis prøveperiode',
  'login.adminLogin': '🔒 Administratorlogin',
  'login.enterPin': 'Indtast din PIN-kode',
  'login.changeTenant': 'Skift firma',
  'login.clear': 'Ryd',
  'login.delete': 'Slet',
  'login.login': 'Log ind',
  'login.loggingIn': 'Logger ind...',
  'login.defaultPinOwner': 'Standard PIN: <strong>1234</strong> (Ejer)',
  'login.defaultPinCashier': 'Standard PIN: <strong>0000</strong> (Kasserer)',
  'login.systemInitializing': 'Initialiserer system...',
  'login.pinMinLength': 'PIN skal være mindst 4 cifre',
  'login.invalidTenantId': 'Indtast et gyldigt firma-ID',
  'login.tenantNotFound': 'Denne firmakode blev ikke fundet. Tjek eller opret en ny konto.',
  'login.loginFailed': 'Login mislykkedes',
  'login.welcome': 'Velkommen, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',

  'signup.title': 'Start gratis prøveperiode',
  'signup.subtitle': '15 dage gratis, intet kreditkort påkrævet',
  'signup.backToLogin': 'Tilbage til login-siden',
  'signup.companyCode': 'Firmakode',
  'signup.companyCodePlaceholder': 'f.eks: cleanpro',
  'signup.companyCodeHelp': 'Denne kode vil blive brugt til at logge ind i systemet',
  'signup.companyCodeMinLength': 'Firmakode skal være mindst 3 tegn',
  'signup.companyName': 'Firmanavn',
  'signup.companyNamePlaceholder': 'Dit firmanavn',
  'signup.companyNameRequired': 'Firmanavn er påkrævet',
  'signup.fullName': 'Fulde navn',
  'signup.fullNamePlaceholder': 'Dit fulde navn',
  'signup.fullNameRequired': 'Fulde navn er påkrævet',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+45 20 12 34 56',
  'signup.validPhoneRequired': 'Indtast et gyldigt telefonnummer',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Indtast en gyldig e-mailadresse',
  'signup.createAccount': 'Opret konto',
  'signup.creating': 'Opretter...',
  'signup.terms': 'Ved at oprette en konto accepterer du servicevilkårene og fortrolighedspolitikken.',
  'signup.success': 'Registrering lykkedes! Dine loginoplysninger er sendt til din e-mail.',
  'signup.successTitle': 'Registrering lykkedes!',
  'signup.successMessage': 'Din konto er blevet oprettet.',
  'signup.emailSent': 'Dine loginoplysninger er sendt til din e-mail.',
  'signup.redirecting': 'Omdirigerer til login-siden...',
  'signup.startupPackageLoaded': 'Startpakke indlæst!',
  'signup.products': 'Produkter',
  'signup.customers': 'Kunder',
  'signup.users': 'Brugere',
  'signup.demoDataReady': '✨ Dine demo-data er klar, du kan begynde at bruge dem med det samme!',
  'signup.loginInfo': '📧 Dine loginoplysninger',
  'signup.loginInfoSent': '💡 Disse oplysninger er også sendt til din e-mail',
  'signup.loginNow': 'Log ind nu →',
};
